'use strict';

import $ from 'jquery';
import Swiper from 'swiper';
import 'bootstrap';
import 'waypoints/lib/noframework.waypoints.min.js';
import {
  TimelineMax
} from 'gsap';
import AOS from 'aos';

window.$ = $;
window.jQuery = $;

window.Swiper = Swiper;
window.TimelineMax = TimelineMax;
window.AOS = AOS;

// # myaward-artist - 나와 아티스트 <좋아하는 1명>
const _timeLineForArtistTypeCase1 = ($currentContents) => { 
  const $artistImg = $currentContents.find('.artist__like-img'),
		$artistName = $currentContents.find('.artist__like-name'),
    $tag1 = $currentContents.find('.artist__like-tag.tag1'),
    $tag2 = $currentContents.find('.artist__like-tag.tag2'),
    $tag3 = $currentContents.find('.artist__like-tag.tag3');

  const tl = new TimelineMax({ delay: 0.1 });

  tl.add('all')
    .staggerFrom([$artistImg, $artistName, $tag1, $tag2, $tag3], 0.8, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all');

  tl.pause();

  return tl;
};
// # myaward-artist - 나와 아티스트 <좋아하는 3명>
const _timeLineForArtistTypeCase3 = ($currentContents) => { 
  const $artistThumb1 = $currentContents.find('.artist__like-team.team1'),  
    $artistThumb2 = $currentContents.find('.artist__like-team.team2'),  
    $artistThumb3 = $currentContents.find('.artist__like-team.team3'),  
    $tag1 = $artistThumb1.find('.artist__like-tag'),
    $tag2 = $artistThumb2.find('.artist__like-tag'),
    $tag3 = $artistThumb3.find('.artist__like-tag');

  const tl = new TimelineMax({ delay: 0.3 });

  tl.add('all')
    .staggerFrom([$artistThumb1, $artistThumb2, $artistThumb3], 1, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all')
    .staggerFrom([$tag1, $tag2, $tag3], 1, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all+=0.5');

  tl.pause();

  return tl;
};
// # myaward-artist - 나와 아티스트 <처음 만난 아티스트>
const _timeLineForArtistFirstTypeCase = ($currentContents) => { 
  const $artistBtn1 = $currentContents.find('.artist__first-btn:first-child'),
		$artistBtn2 = $currentContents.find('.artist__first-btn:nth-child(2)'),
		$artistBtn3 = $currentContents.find('.artist__first-btn:nth-child(3)'),
		$artistThumb1 = $artistBtn1.find('.artist__first-img'),
    $artistThumb2 = $artistBtn2.find('.artist__first-img'),
    $artistThumb3 = $artistBtn3.find('.artist__first-img'),
    $tag1 = $artistBtn1.find('.artist__first-tx'),
    $tag2 = $artistBtn2.find('.artist__first-tx'),
    $tag3 = $artistBtn3.find('.artist__first-tx');

  const tl = new TimelineMax({ delay: 0.1 });

  tl.add('all')
    .staggerFrom([$artistThumb1, $artistThumb2, $artistThumb3], 0.8, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all')
    .staggerFrom([$tag1, $tag2, $tag3], 0.8, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.35, 'all+=0.2');

  tl.pause();

  return tl;
};
// # myaward-activity - 나의 멜론 활동 <팬맺기 활동>
const _timeLineForActivityTypeCase3 = ($currentContents) => { 
  const $artistTeam1 = $currentContents.find('.activity__fan-team.team1'),
    $artistTeam2 = $currentContents.find('.activity__fan-team.team2'),
    $artistTeam3 = $currentContents.find('.activity__fan-team.team3');

  const tl = new TimelineMax({ delay: 0.1 });

  tl.add('all')
    .staggerFrom([$artistTeam1, $artistTeam2, $artistTeam3], 0.8, { ease: "elastic.out(1, 0.75)", autoAlpha: 0, scale: 0 }, 0.2, 'all');

  tl.pause();

  return tl;
};

window.aniType = {};

// # myaward-artist - 나와 아티스트 <좋아하는 1명>
aniType.artistTypeCase1 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.artistTypeCase1.tl) {
      aniType.artistTypeCase1.tl = _timeLineForArtistTypeCase1($targetContents)
      aniType.artistTypeCase1.tl.play();
    } else {
      aniType.artistTypeCase1.tl.restart(true, false);
    }
  }
}
// # myaward-artist - 나와 아티스트 <좋아하는 3명>
aniType.artistTypeCase3 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.artistTypeCase3.tl) {
      aniType.artistTypeCase3.tl = _timeLineForArtistTypeCase3($targetContents)
      aniType.artistTypeCase3.tl.play();
    } else {
      aniType.artistTypeCase3.tl.restart(true, false);
    }
  }
}
// # myaward-activity - 나의 멜론 활동 <팬맺기 활동>
aniType.activityTypeCase3 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.activityTypeCase3.tl) {
      aniType.activityTypeCase3.tl = _timeLineForActivityTypeCase3($targetContents)
      aniType.activityTypeCase3.tl.play();
    } else {
      aniType.activityTypeCase3.tl.restart(true, false);
    }
  }
}
// # myaward-artist - 나와 아티스트 <처음 만난 아티스트 3명>
aniType.activityFavoritTypeCase3 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.activityFavoritTypeCase3.tl) {
      aniType.activityFavoritTypeCase3.tl = _timeLineForArtistFirstTypeCase($targetContents)
      aniType.activityFavoritTypeCase3.tl.play();
    } else {
      aniType.activityFavoritTypeCase3.tl.restart(true, false);
    }
  }
}

// # myaward-artist - 나와 아티스트 <처음 만난 아티스트 2명>
aniType.activityFavoritTypeCase2 = {
  tl: null,
  start: function ($targetContents) {
    if (!aniType.activityFavoritTypeCase2.tl) {
      aniType.activityFavoritTypeCase2.tl = _timeLineForArtistFirstTypeCase($targetContents)
      aniType.activityFavoritTypeCase2.tl.play();
    } else {
      aniType.activityFavoritTypeCase2.tl.restart(true, false);
    }
  }
}

$(function () {
	// waypoints
	$('.myawards__sec').each(function (i,el) {
		var waypoint = new Waypoint({
			element: el,
			handler: function (direction) {
				if (direction == 'down') {
					checkSection($(el));
				}
			},
			offset: 150,
		})
  });
  
  AOS.init({
    duration: 1200
  });

	// tab
	$('._js_tab_btn').on('click', function(e) {
		var target = $(e.currentTarget),
				targetIndex = target.index(),
				tabBox = target.closest('._js_tab'),
				tabPannel = tabBox.find('._js_tab_pannel');

		tabBox.find('._js_tab_btn').removeClass("isActive");
		target.addClass("isActive");
		tabPannel.eq(targetIndex).addClass("isActive").siblings().removeClass("isActive");
	})

	// toggle
	$('.myawards__notice-title').on('click', function(e) {
		var target = $(e.currentTarget);
		target.closest('.myawards__event-notice').toggleClass('on');
		target.next(".myawards__notice").slideToggle(100);
	})
});